<ng-container *transloco="let translate">
  <div class="fut-small fut-bold fut-chip-label fut-gap-4" [futTooltip]="betaTooltip">
    <span>{{ translate('beta.label') }}</span>
    <mat-icon fontSet="material-symbols-outlined" class="fut-chip-icon custom-margin">info</mat-icon>
  </div>

  <ng-template #betaTooltip>
    <span>{{ translate('beta.tooltip') }}</span>
  </ng-template>
</ng-container>
